<search-input
  [placeholder]="'search_shop_dish' | translate"
  [debounceTime]="650"
  (searchInput)="onSearch($event)"
  (focusInput)="onFocus($event)"
  (clearInput)="onClear()"
  (keyboardEnterInput)="onKeydownEnter($event)"
  (keyboardEscape)="onEscape()"
  role="search"
  [attr.aria-label]="'search_shop_dish' | translate"
></search-input>
